import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      className="flex flex-wrap items-center gap-1.5 text-sm text-secondary-500"
      aria-label="面包屑导航"
    >
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link
              to={item.to}
              className="flex items-center gap-1 transition-colors hover:text-accent-600"
            >
              {index === 0 && <i className="ri-home-4-line"></i>}
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-secondary-400"></i>
          )}
        </span>
      ))}
    </nav>
  );
}